import communications from '../communications';
import delay from '../delay';

export default (data) => {
  return communications.outgoing(delay.outgoing(data));
};
